import { loadDeferredSlideAnswerCounts } from '@/utils/lazySlideAnswerCounts'

const FLAG = 'SYST-929-lazy-slide-answer-counts'

// After the commit, not in setSlideActiveAction: a view transition commits the slide a frame
// later, and an earlier count write would be overwritten by the slide it then commits.
// flagGate and the slide API import the store, so they are required lazily to avoid an import cycle.
export default (store) => {
  store.subscribe((mutation) => {
    if (mutation.type !== 'setSlideActive') return
    // eslint-disable-next-line global-require
    const { runFlagged, captureFlagError } = require('@/services/flagGate')
    runFlagged(FLAG, () => {
      // eslint-disable-next-line global-require
      const SlideApi = require('@/api/slide').default
      loadDeferredSlideAnswerCounts(store, mutation.payload && mutation.payload.id, {
        fetchSlides: (ids, presentationId) => SlideApi.listSlidesDetail({ ids: ids.join(','), presentationId }),
        fetchSlide: (id) => SlideApi.getSlideById(id),
        onError: (error) => captureFlagError(error, FLAG),
      })
    })
  })
}
